const InterventionType = {
  CREATION: 'CreationInterventionProxy',
  DEMANDE_DESTOCKAGE: 'DemandeDestockageInterventionProxy',
  ANNULATION_DESTOCKAGE: 'AnnulationDestockageInterventionProxy',
  MODIFICATION: 'ModificationInterventionProxy',
}

export default InterventionType
